export default "/assets/website/images/chevron-next.svg?e5f64ba572bfad62df59d3b94a350de2";